import {
  Button,
  Flex,
  Paper,
  TextInput,
  Text,
  Loader,
  Blockquote,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import {
  CreateCustomFieldRequest,
  useCreateCustomFieldMutation,
} from "../slices/api/ventsApi";
import { initialize, updateField } from "../slices/form/createCustomField";
import { useEffect } from "react";
import { IconInfo } from "../shared/components/Icons";
import { CustomFieldTypeControl } from "../shared/components/CustomFieldTypeControl";
import { useLocation } from "wouter";

interface Props {
  title: string;
  ventId: string;
  updateTime: string;
  onClose: () => void;
}
const CreateCustomField = (props: Props) => {
  const { data } = useAppSelector(
    (state: RootState) => state.createCustomFieldForm
  );
  const [createCustomField] = useCreateCustomFieldMutation();
  const [_, navigate] = useLocation();

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      initialize({
        fieldType: "o",
        name: "",
      })
    );
  }, []);

  const handleClick = async () => {
    if (data == null) {
      console.error("Data is null but should not be");
      return;
    }
    if (data.name == null) {
      displayErrorMessage("Name is required.");
      return;
    }

    const request: CreateCustomFieldRequest = {
      ventId: props.ventId,
      name: data.name,
      fieldType: data.fieldType,
      updateTime: props.updateTime,
    };

    try {
      const response = await createCustomField(request).unwrap();
      props.onClose();
      props.onClose();
      navigate(
        `/console/customfield/event/${props.ventId}/customfield/${response.id}`
      );
    } catch (error) {
      displayServerErrorMessage(error);
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  return (
    <>
      <Paper>
        <Text size="lg">{props.title}</Text>
        <TextInput
          maxLength={100}
          required
          mt="md"
          label="Name"
          value={data.name ?? ""}
          onChange={(event) => {
            dispatch(
              updateField({
                field: "name",
                value: event.currentTarget.value,
              })
            );
          }}
        />
        <CustomFieldTypeControl
          label="Field Type"
          mt="lg"
          value={data.fieldType}
          onChange={(value) =>
            dispatch(
              updateField({
                field: "fieldType",
                value: value,
              })
            )
          }
        />
        <Blockquote color="blue" icon={<IconInfo />} mt="xl">
          The "text" field type allows the users to enter up to 100 characters
          of free text. The "options" field type allows the user to select one
          or more items from a set of items.
          <br />
          <br />
          You cannot change the type of this custom field once it is created.
        </Blockquote>
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Cancel
          </Button>
          <Button mt="md" onClick={handleClick}>
            Save
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default CreateCustomField;
